import React, { useState, useEffect } from "react";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getVisaById,
  getAllVisas,
  resetVisaUpdate,
  resetVisaDetails,
  updateVisa,
} from "../features/visa/visaSlice";
import { getAllPassports } from "../features/passport/passportSlice";
import { AiFillEdit, AiOutlineRollback } from "react-icons/ai";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import Moment from "react-moment";

const UpdateVisa = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [visaName, setVisaName] = useState("");

  const [visaId, setId] = useState("");
  const [visaNumber, setNumber] = useState("");
  const [visaType, setType] = useState("");
  const [visaCountry, setCountry] = useState("");
  const [profession, setProfession] = useState("");
  const [salary, setSalary] = useState("");
  const [visaOfficeName, setOfficeName] = useState("");
  const [visaOfficePhone, setOfficePhone] = useState("");
  const [visaAddress, setAddress] = useState("");
  const [visaRate, setRate] = useState("");
  const [visaQuantity, setQuantity] = useState("");
  const [totalRate, setTotalRate] = useState(visaRate * visaQuantity);
  const [visaContactAmount, setContactAmount] = useState("");
  const [visaPaidAmount, setPaidAmount] = useState("");
  const [visaDueAmount, setDueAmount] = useState(
    visaContactAmount - visaPaidAmount
  );
  const [timestamps, setTimestamps] = useState("");

  const [CompanyName, setCompanyName] = useState("");

  const [visaNames, setVisaNames] = useState([]);
  const [allPassports, setAllPassports] = useState([]);

  const { userInfo } = useSelector((state) => state.user);

  const {
    visa,
    isDeatilsLoading,
    isDetailsSuccess,
    isDetailsError,
    detailsErrorMessage,

    isUpdateLoading,
    isUpdateError,
    isUpdateSuccess,
    updateErrorMessage,
  } = useSelector((state) => state.visa);

  const {
    passports,
    isListLoading,
    isListSuccess,
    isListError,
    listErrorMessage,
  } = useSelector((state) => state.passport);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login to Get Access", {
        position: "top-center",
      });
      navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setVisaName(visa.visaName);
      setId(visa.visaId);
      setNumber(visa.visaNumber);
      setType(visa.visaType);
      setCountry(visa.visaCountry);
      setProfession(visa.profession);
      setSalary(visa.salary);
      setOfficeName(visa.visaOfficeName);
      setOfficePhone(visa.visaOfficePhone);
      setAddress(visa.visaAddress);
      setRate(visa.visaRate);
      setQuantity(visa.visaQuantity);
      setTotalRate(visa.totalRate);
      setContactAmount(visa.visaContactAmount);
      setPaidAmount(visa.visaPaidAmount);
      setDueAmount(visa.visaDueAmount);
      setTimestamps(visa.timestamps);
    } else {
      dispatch(getVisaById(params.id));
    }
  }, [isDetailsError, isDetailsSuccess, detailsErrorMessage, visa]);

  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Visa Updated Successfully", {
        position: "top-center",
      });
      dispatch(getAllVisas());
      navigate("/visaList");
    }
  }, [isUpdateError, isUpdateSuccess, updateErrorMessage, navigate]);

  // Get all Passports
  useEffect(() => {
    if (isListError) {
    } else if (isListSuccess) {
      setAllPassports(passports);
    } else {
      dispatch(getAllPassports());
    }
  }, [dispatch, isListError, isListSuccess, listErrorMessage, passports]);

  useEffect(() => {
    setDueAmount(visaContactAmount * 1 - visaPaidAmount * 1);
  }, [visaContactAmount, visaPaidAmount, visaDueAmount]);

  useEffect(() => {
    setTotalRate(visaRate * 1 * visaQuantity * 1);
  }, [visaRate, visaQuantity, totalRate]);

  useEffect(() => {
    return () => {
      dispatch(resetVisaDetails());
      dispatch(resetVisaUpdate());
    };
  }, [dispatch]);

  const updateHandler = () => {
    const visa = {
      visaName,
      visaId,
      visaNumber,
      visaType,
      visaCountry,
      profession,
      salary,
      visaOfficeName,
      visaOfficePhone,
      visaAddress,
      visaRate,
      visaQuantity,
      totalRate,
      visaContactAmount,
      visaPaidAmount,
      visaDueAmount,
      timestamps,
    };
    dispatch(updateVisa({ id: params.id, visa }));
  };

  const handleCompanySelect = (e) => {
    if (e.target.value !== "") {
      setVisaName(e.target.value);
    } else {
      setVisaName("");
    }
  };

  return (
    <Container fluid className="my-4">
      <h2 style={{ fontWeight: "bold " }} className="mb-4 text-center">
        Update Visa
      </h2>
      <>
        {isDeatilsLoading || isUpdateLoading ? (
          <Loader />
        ) : isDetailsError ? (
          <h4 variant="danger">{detailsErrorMessage}</h4>
        ) : (
          <Form>
            <Col sm={12} md={12} lg={12}>
              <Card className="mb-4 shadow rounded">
                <Card.Header
                  as="h5"
                  className="text-black text-center fw-bold p-3"
                  style={{ backgroundColor: "#74a2e3" }}
                >
                  Visa Information
                </Card.Header>

                <Card.Body className="fw-bold">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaName">
                        <Form.Label style={{ color: "black" }}>
                          Visa Name
                        </Form.Label>
                        <Form.Select
                          as="select"
                          value={visaName}
                          onChange={(e) => handleCompanySelect(e)}
                        >
                          <option value="">Select Office</option>

                          {passports &&
                            passports.map((passport) => (
                              <option
                                key={passport._id}
                                value={passport.company}
                              >
                                {passport.company}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaId">
                        <Form.Label style={{ color: "black" }}>
                          Visa ID
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaId === "" ? "ID is Required" : "Enter Visa ID"
                          }
                          value={visaId}
                          onChange={(e) => setId(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaNumber">
                        <Form.Label style={{ color: "black" }}>
                          Visa Number
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaNumber === ""
                              ? "Number is Required"
                              : "Enter Visa Number"
                          }
                          value={visaNumber}
                          onChange={(e) => setNumber(e.target.value)}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaType">
                        <Form.Label style={{ color: "black" }}>
                          Visa Type
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaType === ""
                              ? "Type is Required"
                              : "Enter Visa Type"
                          }
                          value={visaType}
                          onChange={(e) => setType(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaCountry">
                        <Form.Label style={{ color: "black" }}>
                          Visa Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaCountry === ""
                              ? "Country is Required"
                              : "Enter Visa Country"
                          }
                          value={visaCountry}
                          onChange={(e) => setCountry(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="profession">
                        <Form.Label style={{ color: "black" }}>
                          Profession
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            profession === ""
                              ? "Profession is Required"
                              : "Enter Profession"
                          }
                          value={profession}
                          onChange={(e) => setProfession(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="salary">
                        <Form.Label style={{ color: "black" }}>
                          Salary
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            salary === ""
                              ? "Salary is Required"
                              : "Enter Salary"
                          }
                          value={salary}
                          onChange={(e) => setSalary(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaOfficeName">
                        <Form.Label style={{ color: "black" }}>
                          Visa Office Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaOfficeName === ""
                              ? "Office Name is Required"
                              : "Enter Visa Office Name"
                          }
                          value={visaOfficeName}
                          onChange={(e) => setOfficeName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaOfficePhone">
                        <Form.Label style={{ color: "black" }}>
                          Visa Office Phone
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaOfficePhone === ""
                              ? "Office Phone is Required"
                              : "Enter Visa Office Phone"
                          }
                          value={visaOfficePhone}
                          onChange={(e) => setOfficePhone(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaAddress">
                        <Form.Label style={{ color: "black" }}>
                          Visa Address
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaAddress === ""
                              ? "Address is Required"
                              : "Enter Visa Address"
                          }
                          value={visaAddress}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaRate">
                        <Form.Label style={{ color: "black" }}>
                          Visa Rate
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaRate === ""
                              ? "Rate is Required"
                              : "Enter Visa Rate"
                          }
                          value={visaRate}
                          onChange={(e) => setRate(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaQuantity">
                        <Form.Label style={{ color: "black" }}>
                          Visa Quantity
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaQuantity === ""
                              ? "Quantity is Required"
                              : "Enter Visa Quantity"
                          }
                          value={visaQuantity}
                          onChange={(e) => setQuantity(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="totalRate">
                        <Form.Label style={{ color: "black" }}>
                          Total Rate
                        </Form.Label>
                        <Form.Control
                          type="text"
                          disabled
                          placeholder={
                            totalRate === ""
                              ? "Rate is Required"
                              : "Enter Total Rate"
                          }
                          value={totalRate}
                          onChange={(e) => setTotalRate(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group
                        className="mb-3"
                        controlId="visaContactAmount"
                      >
                        <Form.Label style={{ color: "black" }}>
                          Visa Contact Amount
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaContactAmount === ""
                              ? "Amount is Required"
                              : "Enter Visa Contact Amount"
                          }
                          value={visaContactAmount}
                          onChange={(e) => setContactAmount(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaPaidAmount">
                        <Form.Label style={{ color: "black" }}>
                          Visa Paid Amount
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={
                            visaPaidAmount === ""
                              ? "Amount is Required"
                              : "Enter Visa Paid Amount"
                          }
                          value={visaPaidAmount}
                          onChange={(e) => setPaidAmount(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="visaDueAmount">
                        <Form.Label style={{ color: "black" }}>
                          Visa Due Amount
                        </Form.Label>
                        <Form.Control
                          type="text"
                          disabled
                          placeholder=""
                          value={visaDueAmount}
                          onChange={(e) => setDueAmount(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* </Row> */}

                  <Row className="mt-4">
                    <Col sm={12} md={6} lg={6} className="px-4">
                      <Row>
                        <Button
                          variant="outline-primary"
                          type="submit"
                          className="rounded"
                          onClick={updateHandler}
                        >
                          <AiFillEdit className="mb-1" size={18} />
                          Update Visa
                        </Button>
                      </Row>
                    </Col>

                    <Col sm={12} md={6} lg={6} className="px-4">
                      <Row>
                        <LinkContainer to={`/visaList`}>
                          <Button
                            variant="outline-secondary"
                            className="rounded"
                          >
                            <AiOutlineRollback className="mb-1" size={18} />
                            Back To List
                          </Button>
                        </LinkContainer>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Form>
        )}
      </>
    </Container>
  );
};

export default UpdateVisa;
